'use client';

import React, { type ReactElement } from 'react';

import { TOP_MESSAGE_BAR_HEIGHT_PX } from '@/common/constants/top-message-bar.constant';
import useTopMessageBar from '@/common/hooks/use-top-message-bar.hook';
import { isVisibleTopMessageBar } from '@/common/utils/top-message-bar.utility';

export default function TopMessageBar(): ReactElement | null {
  const { configuration } = useTopMessageBar();

  if (!isVisibleTopMessageBar(configuration)) {
    return null;
  }

  return (
    <div
      role="status"
      className="relative z-[100] flex w-full shrink-0 items-center justify-center px-4"
      style={{
        height: TOP_MESSAGE_BAR_HEIGHT_PX,
        backgroundColor: configuration.backgroundColor ?? undefined,
        color: configuration.textColor ?? undefined,
        boxShadow: 'inset 0 -1px 0 rgb(0 0 0 / 0.08)',
      }}
    >
      <p
        dir="auto"
        className="w-full text-center text-base font-medium leading-none tracking-[0.01em] whitespace-nowrap"
      >
        {configuration.message}
      </p>
    </div>
  );
}
